import * as React from 'react'
import TemplateIcon from './templateIcon'

const TemplateIcons = ({ icons, iconsLarge = false, inCard = true, inVersions = false }) => {
  const wrapperClassBase = [
    'flex justify-center items-center pointer-events-none',
    inCard ? 'absolute inset-0' : '',
    iconsLarge ? 'space-x-3 md:space-x-6' : 'space-x-3',
  ]

  // const iconWrapperClassBase = [
  //   'flex items-center justify-center rounded-full bg-white',
  //   inCard ? 'shadow-2xl border-2 border-gray-900' : 'shadow-xl',
  //   iconsLarge && inCard ? 'p-3 md:p-6' : 'p-3'
  // ]
  //
  // const iconWh = iconsLarge && inCard
  //   ? 'w-6 sm:w-10 md:w-14 lg:w-20 h-6 sm:h-10 md:h-14 lg:h-20'
  //   : 'w-6 sm:w-10 h-6 sm:h-10'

  if (icons) {
    return (
      <div className={wrapperClassBase.join(' ')}>
        {icons.map((icon) => (
          <TemplateIcon
            key={icon}
            icon={icon}
            shadow={!inCard}
            shadowLarge={inCard}
            border={inCard}
            wrapperLarge={iconsLarge && inCard}
            iconLarge={iconsLarge && inCard}
          />
        ))}
      </div>
    )
  }

  return null
}

export default TemplateIcons
